import { DashboardWidgetDefinition } from 'src/app/shared/dashboard-grid';
import { DashboardFilters } from '../../dashboard.state';

/** The tile's Counter, by its id in the Usage Metric Catalog */
export interface TrendsSettings {
  counter: string;
}

/** One Counter from the Usage Metric Catalog over time; each instance's settings choose its Counter. */
export const TRENDS_WIDGET: DashboardWidgetDefinition<TrendsSettings, DashboardFilters> = {
  type: 'trends',
  title: 'Dashboard.Trends.Title',
  description: 'A usage count over time, such as chat messages posted. Add one per Counter.',
  icon: 'trending_up',
  loadComponent: () => import('./trends-widget.component').then((m) => m.TrendsWidgetComponent),
  /** Names itself after its Counter, like the Metric tile; the type's icon ends the label row */
  header: false,
  size: { default: { w: 5, h: 3 }, min: { w: 4, h: 3 } },
  /** No Counter chosen: the tile shows the catalog's first, so '' is valid */
  defaultSettings: { counter: '' },
  filtersFor: () => ['timeRange'],
  settingsSchema: {
    type: 'object',
    properties: { counter: { type: 'string' } },
    required: ['counter'],
  },
  loadSettingsComponent: () => import('./trends-settings.component').then((m) => m.TrendsSettingsComponent),
  maxInstances: Infinity,
};
